import { CSVTranformationProfile, CSVProfile } from '../../types'
import { BaseVisualization } from '../base/base-visualization-component'

export class ContentGridComponent extends BaseVisualization {
 static config = {
  selector: 'contentGridComponent',
  controller: ContentGridComponent,
  template: `
            <!--
            <div layout="row" layout-wrap flex>
                <div flex layout="column" flex-gt-xs="30"
                    ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.contentDocuments)"
                    ng-repeat="item in $ctrl.contentDocuments">

                    <div class="flex-item"> {{item.name}} </div>

                    <div class="flex-item">
                        <md-card>
                            <img ng-src="{{item.imageUrl}}" class="md-card-image" alt="Washed Out">

                            <md-card-header>
                                <md-card-avatar> <img src="img/logo.svg"> </md-card-avatar>
                                <md-card-header-text>
                                    <span class="md-title">The Washinton Post . Samantha West </span>
                                    <span class="md-subhead">US | January 19, 2019</span>
                                </md-card-header-text>
                            </md-card-header>

                            <md-card-title>
                                <md-card-title-text>
                                    <span class="mw-card-grid-list__card-title-text">{{item.title}}</span>
                                </md-card-title-text>
                            </md-card-title>
                            <md-card-content>
                                {{item.description}}
                            </md-card-content>
                            <md-card-actions layout="row" layout-align="end center">
                                <md-button>343M Reach</md-button>
                                <md-button>Social Echo</md-button>
                                <md-button>Action Negative</md-button>
                            </md-card-actions>
                        </md-card>
                    </div>

                </div>
            </div>
            -->


            <md-grid-list class="mw-card-grid-list__grid-list" style="height: 1024px;"
            md-cols-xs='1' md-row-height-xs='350px'
            md-cols-sm='2' md-row-height-sm='480px'
            md-cols-md='3' md-row-height-md='480px'
            md-cols-lg='3' md-row-height-lg='550px'
            md-cols-xl='3' md-row-height-xl='550px'
            md-gutter='24px'>
                <md-grid-tile ng-repeat="contentDocument in $ctrl.contentDocuments">
                <div layout="column">
                    <div class="flex-item">
                        <span style="padding-right: 20px;">
                            <md-icon md-svg-icon="meltwater:circle-closed" 
                                ng-style="{'width': '10px', 'min-width': '10px', 'color': contentDocument.color}">
                            </md-icon> 
                            {{contentDocument.name}}
                        </span>
                    </div>

                    <md-card class="mw-content-stream__card-container">
                        <mw-media-document 
                            document="contentDocument"
                            display-mode="$ctrl.displayMode"
                            is-selectable="$ctrl.displaySettings.isSelectable"
                            is-avatar-visible="$ctrl.displaySettings.isAvatarVisible"
                            is-avatar-padding-on="$ctrl.displaySettings.isAvatarPaddingOn"
                            is-title-visible="$ctrl.displaySettings.isTitleTextVisible"
                            is-ingress-visible="$ctrl.displaySettings.isIngressVisible"
                            is-match-sentence-visible="$ctrl.displaySettings.isMatchSentenceVisible"
                            is-media-visible="$ctrl.displaySettings.isMediaVisible"
                            is-media-placeholder-visible="$ctrl.displaySettings.isMediaPlaceholderVisible"
                            media-emphasis="$ctrl.displaySettings.mediaEmphasis"
                            is-keywords-visible="$ctrl.displaySettings.isKeywordsVisible"
                            is-tags-visible="$ctrl.displaySettings.isTagsVisible"
                            is-reach-visible="$ctrl.displaySettings.isReachVisible"
                            is-duplicates-visible="$ctrl.displaySettings.isDuplicatesVisible"
                            is-sentiment-visible="$ctrl.displaySettings.isSentimentVisible"
                            is-fixed-media-aspect-ratio="$ctrl.displaySettings.isFixedMediaAspectRatio"
                            is-blur-enabled="$ctrl.displaySettings.isBlurEnabled"
                            is-inline-sentiment-enabled="$ctrl.displaySettings.inlineSentiment"
                            is-social-echo-visible="$ctrl.displaySettings.isSocialEchoVisible"
                            is-social-engagement-visible="$ctrl.displaySettings.isSocialEngagementVisible"
                            on-select-toggle="$ctrl.toggleDocumentSelection($event.document)"
                            on-sentiment-update="$ctrl.handleSentimentUpdate($event.document, $event.sentiment)"
                            on-sentiment-reset="$ctrl.handleSentimentReset($event.document)"
                            on-tag-removal="$ctrl.handleTagRemoval($event.document, $event.tag)"
                            on-title-click="$ctrl.handleHostedContentClick($event)"
                            on-timestamp-click="$ctrl.handleHostedContentClick($event)"
                            on-avatar-click="$ctrl.handleHostedContentClick($event)"
                            timezone="$ctrl.demosTimezoneService.timezone"
                            active-tray-content="$ctrl.activeTrayContent"
                            is-document-clickable="$ctrl.displaySettings.isDocumentClickable"
                            on-document-click="$ctrl.toggleDocumentSelection($event.document)"
                            >
                        </mw-media-document>
                        <mw-content-document-placeholder
                            ng-if="$ctrl.isLoading"
                            is-selectable="$ctrl.displaySettings.isSelectable"
                            display-mode="$ctrl.displayMode"
                            >
                        </mw-content-document-placeholder>
                    </md-card>


                    </div>
                </md-grid-tile>
            </md-grid-list>
        `,
  bindings: BaseVisualization.config.bindings,
 }

 public displayMode = 'indy'

 private displaySettings = {
  isDocumentClickable: false,
  isSelectable: false,
  isAvatarVisible: true,
  isAvatarPaddingOn: false,
  isTitleTextVisible: true,
  isFixedMediaAspectRatio: true,
  isBlurEnabled: true,
  isIngressVisible: true,
  isMatchSentenceVisible: true,
  isMediaVisible: true,
  isMediaPlaceholderVisible: false,
  isKeywordsVisible: false,
  isKeywordsClickable: false,
  isTagsVisible: true,
  isDuplicatesVisible: true,
  inlineSentiment: false,
  isSocialEchoVisible: true,
  isSocialEngagementVisible: true,
  isHosted: false,
  mediaEmphasis: 'high',
 }

 public reactionColors = ['#F65D8B', '#1DD1A1']
 public seriesColors = [
  '#0194EB',
  '#FFBC45',
  '#F65D8B',
  '#1DD1A1',
  '#FF7845',
  '#545454',
  '#96497B',
  '#3E9189',
  '#956445',
  '#3B5C87',
 ]

 /**
  * List of grid data & option
  */
 public contentDocuments = [
  {
   name: 'Tesla',
   authors: [
    {
     name: 'Diego Romero',
     sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
     url: 'http://www.facebook.com/107855142579272',
    },
   ],
   title: 'Tesla (TSLA) stocks soar in week of record highs.',
   matchSentences: [
    'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
   ],
   mediaImageUrl:
    'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
   date: 1498231166838,
   sentiment: 'P',
   reachCount: '1257601',
   sourceName: 'The Washinton Post',
   sourceCountryCode: 'us',
   socialScores: {
    facebook: {
     shares: 456,
    },
    linkedin: {
     shares: 123,
    },
    twitter: {
     shares: 789,
    },
   },
   color: '#0194EB',
  },
  {
   name: 'Audio',
   authors: [
    {
     name: 'Ebenezer Isaac',
     sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
     url: 'http://www.facebook.com/107855142579272',
    },
   ],
   title: 'Tesla (TSLA) stocks soar in week of record highs.',
   matchSentences: [
    'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
   ],
   mediaImageUrl:
    'https://images.unsplash.com/photo-1464278533981-50106e6176b1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
   date: 1498231166838,
   sentiment: 'P',
   reachCount: '1257601',
   sourceName: 'The Washinton Post',
   sourceCountryCode: 'us',
   socialScores: {
    facebook: {
     shares: 456,
    },
    linkedin: {
     shares: 123,
    },
    twitter: {
     shares: 789,
    },
   },
   color: '#FFBC45',
  },
  {
   name: 'Toyota',
   authors: [
    {
     name: 'Diego Romero',
     sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
     url: 'http://www.facebook.com/107855142579272',
    },
   ],
   title: 'Tesla (TSLA) stocks soar in week of record highs.',
   matchSentences: [
    'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
   ],
   mediaImageUrl:
    'https://images.unsplash.com/photo-1496857239036-1fb137683000?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
   date: 1498231166838,
   sentiment: 'N',
   reachCount: '1257601',
   sourceName: 'The Washinton Post',
   sourceCountryCode: 'us',
   socialScores: {
    facebook: {
     shares: 456,
    },
    linkedin: {
     shares: 123,
    },
    twitter: {
     shares: 789,
    },
   },
   color: '#F65D8B',
  },
  {
   name: 'Tesla',
   authors: [
    {
     name: 'Diego Romero',
     sourceAvatarImgUrl: 'http://graph.facebook.com/107855142579272/picture?type=large',
     url: 'http://www.facebook.com/107855142579272',
    },
   ],
   title: 'Tesla (TSLA) stocks soar in week of record highs.',
   matchSentences: [
    'ships them worldwide. Tesla produces its newest 2170 lithium ion battery cells – the same cells being used in Tesla’s Model 3 – exclusively',
   ],
   mediaImageUrl:
    'https://images.unsplash.com/photo-1475724017904-b712052c192a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
   date: 1498231166838,
   sentiment: 'U',
   reachCount: '1257601',
   sourceName: 'The Washinton Post',
   sourceCountryCode: 'us',
   socialScores: {
    facebook: {
     shares: 456,
    },
    linkedin: {
     shares: 123,
    },
    twitter: {
     shares: 789,
    },
   },
   color: '#1DD1A1',
  },
 ]

 // default CSV header columns. Can be overriden in sub class.
 //TODO: Ask Nick what the top content CSV export format should look like.
 public csvHeaders = ['Category', 'Count']

 /**
  * CSV transformation profile. Defines how csv key value transformed
  */
 public transformationProfiles: CSVTranformationProfile[] = []

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (this.hasChanges(changes.vizData)) {
   this.setProperties()
   this.prepareVisualizations(changes.vizData.currentValue)
   this.buildCSVExportProfile()
  }
 }

 setProperties() {}

 prepareVisualizations(payload) {}

 /**
  * Build CSV export profile which includes data, options
  * and the key transformation types if any.
  */
 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
